<template>
    <div class="patient-coaching-summary-notes">
        <b-row class="align-content-around">
            <div class="report-widget col text-center">
                <b-row>
                    <b-col>
                        <label>
                            {{ $i18n.gt('HEADING_NOTES_TO_SELF') }}
                        </label>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-btn class="col btn-sm" variant="primary" @click.stop="showModal()">
                            {{ $i18n.gt('LABEL_VIEW_BUTTON') }}
                            <template v-if="newNotes">
                                <svg v-b-popover.hover.right="$i18n.gt('TOOLTIP_NEW_NOTES')" class="notification-badge"
                                     viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="5" cy="5" r="5"/>
                                </svg>
                            </template>
                        </b-btn>
                    </b-col>
                </b-row>

            </div>
        </b-row>
        <b-modal :id="modalId" :title="$i18n.gt('HEADING_NOTES_TO_SELF')" hide-footer size="lg">
            {{ notes }}
            <b-alert class="mt-3" show>{{ $i18n.gt('TIP_ALLOW_PROVIDERS_VIEW') }}</b-alert>
        </b-modal>
    </div>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>

import Vue from 'vue'
import Utils from '@/providers/Utils'

export default Vue.extend({
    name: 'PatientCoachingSummaryNotes',
    computed: {
        participant() {
            return this.$store.state.patientParticipant
        },
        modalId() {
            return `modal_notes`
        },
        notes() {
            if (this.participant.wellness_plan.mindsetNotes) {
                return this.participant.wellness_plan.mindsetNotes.notes
            } else {
                return null
            }
        },
        newNotes() {
            return ((this.participant.notes_edited > this.participant.notes_viewed_by_provider) || this.participant.notes_edited && !this.participant.notes_viewed_by_provider) && this.participant.allowProviderView
        }
    },
    methods: {
        showModal() {
            this.$bvModal.show(this.modalId)
            // update notes_viewed_by_provider time
            this.$store.state.patientParticipant.notes_viewed_by_provider = Utils.mysqlDatetime(new Date())
            this.$store.dispatch('savePatientParticipant')
        },
    }
})
</script>

<style lang="scss">

.report-widget {
    cursor: pointer;

    .card {
        background: #fff;
        transition: all .3s;
        margin-bottom: 0;
        @media(min-width: 540px) {
            height: 100%;
        }

        &:hover {
            box-shadow: 0 0 10px rgba(0, 0, 0, .15);

            .report-widget__timestamp {
                color: var(blue);
            }
        }
    }

    @media(max-width: 719px) {
        margin-bottom: 1rem;
    }

    .btn-sm.col {
        position: relative;
    }

    .notification-badge {
        fill: var(--red);
        width: 15px;
        height: 15px;
        position: absolute;
        right: -5px;
        top: -5px;
    }

}
</style>
